var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.36538 8.69212H6.09615C7.82692 8.69212 8.6923 7.82674 8.6923 6.09597V4.3652C8.6923 2.63443 7.82692 1.76904 6.09615 1.76904H4.36538C2.63461 1.76904 1.76923 2.63443 1.76923 4.3652V6.09597C1.76923 7.82674 2.63461 8.69212 4.36538 8.69212Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9038 8.69212H17.6346C19.3654 8.69212 20.2308 7.82674 20.2308 6.09597V4.3652C20.2308 2.63443 19.3654 1.76904 17.6346 1.76904H15.9038C14.1731 1.76904 13.3077 2.63443 13.3077 4.3652V6.09597C13.3077 7.82674 14.1731 8.69212 15.9038 8.69212Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9038 20.2307H17.6346C19.3654 20.2307 20.2308 19.3653 20.2308 17.6345V15.9038C20.2308 14.173 19.3654 13.3076 17.6346 13.3076H15.9038C14.1731 13.3076 13.3077 14.173 13.3077 15.9038V17.6345C13.3077 19.3653 14.1731 20.2307 15.9038 20.2307Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.36538 20.2307H6.09615C7.82692 20.2307 8.6923 19.3653 8.6923 17.6345V15.9038C8.6923 14.173 7.82692 13.3076 6.09615 13.3076H4.36538C2.63461 13.3076 1.76923 14.173 1.76923 15.9038V17.6345C1.76923 19.3653 2.63461 20.2307 4.36538 20.2307Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory);
export default __webpack_public_path__ + "static/media/category.7e657d5b08cc46488e8255f3cfbf6e51.svg";
export { ForwardRef as ReactComponent };